import PropTypes from 'prop-types';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
} from '@mui/material';

const CheckboxComponent = (props) => {
  const {
    input,
    label,
    headerLabel,
    meta: { touched, error },
    ...custom
  } = props;
  const hasError = touched && !!error;
  return (
    <FormControl error={hasError} {...custom}>
      <FormLabel component="legend">{headerLabel}</FormLabel>
      <FormControlLabel
        control={
          <Checkbox
            checked={!!input?.value}
            color="primary"
            size="medium"
            sx={{ margin: '-0.8rem 0' }}
            {...input}
            {...custom}
          />
        }
        label={label}
      />
      {hasError && <FormHelperText variant="filled">{error}</FormHelperText>}
    </FormControl>
  );
};

CheckboxComponent.propTypes = {
  input: PropTypes.instanceOf(Object).isRequired,
  meta: PropTypes.instanceOf(Object).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  headerLabel: PropTypes.string,
};

export default CheckboxComponent;
